import { FacebookPageInfluencers, FacebookPageInfluencerProfile } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSelectSocialAccountsForPackage } from './hooks';

export const FacebookPagePackageInfluencersSearch = () => {
  const { getCurrentProfiles, getSortSelectButtonProps, getListSelectButtonProps } =
    useSelectSocialAccountsForPackage<FacebookPageInfluencerProfile>({ socialMedia: InfluencersTabType.FACEBOOK_PAGE });

  return (
    <FacebookPageInfluencers
      isPackagePage
      getCurrentProfiles={getCurrentProfiles}
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
